module.exports = __webpack_public_path__ + "static/media/tv.8b1e73f8.svg";